module.exports = __webpack_public_path__ + "img/route_left.svg";